<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "vastuskuminauhat_6_vinkkia";
    let title = "6 vinkkiä vastuskuminauhojen hyödyntämiseen";
    let author = "Mata";
    let blogDate = "20.9.2014";
    let titlePic = "2014/etunojapunnerrus2.jpg";
    let firstPara = "Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.";
</script>

<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>Kuusi vinkkiä vastuskuminauhojen hyödyntämiseen kuntosaliharjoittelussa</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"/>

            <p>Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. 
            Tässä jutusta saat vinkkejä vastuskuminauhojen eli &quot;kumpparien&quot; hyödyntämiseen omissa treeneissäsi.</p>

            <p>Vastuskuminauha on monikäyttöinen lihaskuntoväline. 
            Kuminauhan aiheuttamaa vastusta voi säädellä valitsemalla ohuemman (löysemmän) tai paksumman (jäykemmän) kuminauhan.
            Kuminauha voi tilanteesta riippuen tuoda lisävastusta tai keventää liikettä, tai sitä voidaan käyttää stabiloijana
            auttamassa tasapainon tai kehon linjausten pitämisessä.</p>

            <p>Alla on koostettuna muutama vinkki vastuskuminauhojen hyödyntämiseen. Ei muuta kuin kokeilemaan!</p>

            <h2>1. Suorituksen keventäminen</h2>
            
            <p>
                Kehonpainoliikkeissä kuminauhojen avulla voidaan keventää kehonpainoa ja siten helpottaa liikettä. 
                Monelle esimerkiksi dippi tai leuanveto omalla painolla on liian raskas liike, 
                jotta se ensimmäinenkään toisto tulisi tehtyä puhtaasti. 
                Valitsemalla sopivan kuminauhan, saadaan hyöty koko liikeradasta ja myös pidempien sarjojen tekeminen onnistuu.</p>
                
            <p>
                Vastuskuminauhaa käyttäessä vastus ei muutu tasaisesti, vaan mitä pidemmäksi kuminauha on venytetty, 
                sitä suuremman vastuksen se aiheuttaa. Esimerkiksi leuanvedossa kuminauhan avustaessa vetoa, 
                liikeradan ala-asennossa kuminauha antama avustus on suurempi kuin yläasennossa. Kannattaa 
                siis pyrkiä tekemään suoritus aivan liikeradan ylös asti jolloin joudut tekemään tosissaan töitä!</p>

                <img src="/svelte-site/img/blog/2014/leuanveto.jpg" alt="kevennetty leuanveto">
                <p class="kuvateksti">Kuminauhalla kevennetty leuanveto</p>
                
            <h2>2. Lihaskuntoharjoittelussa lisävastuksena</h2>

            <p>Vastuskuminauhaa voidaan käyttää muiden harjoitusvälineiden tapaan liikkeen lisäkuormana. 
                Kuminauhoja voidaan hyödyntää niin perusliikkeissä (kyykky, kulmasoutu, pystysoutu) kuin eristetymmissä apuliikkeissä. 
                Erityisen suuri hyöty tulee spesifeissä apuliikkeissä, joissa päästään hyödyntämään vastuskuminauhan ominaispiirre - 
                painovoiman suunnan kumoaminen; kun lisäpaino vie aina alaspäin, voi vastuskuminauhan aiheuttaman voiman suunta olla mikä tahansa.</p>
            
             <img src="/svelte-site/img/blog/2014/etunojapunnerrus.jpg" alt="etunojapunnerrus kuminauhalla" />
             <p class="kuvateksti">Etunojapunnerrus kuminauhavastuksella</p>

            <p>Valitut liikkeet tulee valita aina henkilön tavoitteisiin ja heikkouksiin soveltaen. 
            Esimerkiksi erilaiset olkapään alueelle kohdistuvat vetoliikkeet sekä lonkan alueen harjoitteet onnistuu kuminauhalla erinomaisen hyvin. 
            Myös spesifiset "eristetyt" liikkeet (esim. ojentajapunnerrukset, takareisikoukistukset jne) onnistuvat kuminauhalla erityisen hyvin.</p>


            <h2>3. Kehoa huoltavat liikkeet</h2>

            <p>Kehon pienet tukilihakset ovat usein kaikista haavoittuvimpia ja jäävät herkästi vaille huomiota, 
                ellei niiden harjoitteluun kiinnitetä erityistä huomiota. Harjoittelu lisäpainoilla (esimerkiksi käsipainoilla) 
                voi olla hankalaa koska painot aiheuttavat kuormaa aina suhteessa painovoimaan (alaspäin). Käsipainot ovat myös 
                vakiopainoiset (usein liian painavat tähän tarkoitukseen). Kuminauhoilla voidaan säädellä kuormitusta ja 
                vastuksen suuntaa helpommin sopivaksi.</p>

            <p>Esimerkiksi olkapään alueen ongelmat ovat olkapään anatomiasta johtuen valitettavan yleisiä. 
                Osasyynä on usein pienten kiertäjäkalvosinlihasten heikkous. Kiertäjien vahvistaminen olisikin tärkeää pitää 
                jokaisessa harjoitusohjelmassa mukana ennaltaehkäisevänä huoltoliikkeenä.</p>

            <p>Myös lihasten aktivointiharjoittelu ennen treeniä onnistuu vastuskuminauhaa käyttäen. Esimerkiksi pakaroihin saat tuntumaa, kun lämmittelet ne 
        ensin kuminauhan avulla tekemällä esimerkiksi simpukka- tai loitonnusliikkeitä.</p>

            <img src="/svelte-site/img/blog/2014/olkanivelen_ulkokierto.jpg" alt="olkanivelen ulkokierto" /> 
            <p class="kuvateksti">Olkanivelen ulkokierto</p>

            <h2>4. Venyttelyn tehostaminen</h2>
    
            <p>Venyttelyssä voidaan hyödyntää kuminauhan aiheuttamaa vetoa nivelessä. Yleisesti venyttelyssä kannattaa hyödyntää painovoimaa, 
            jolloin lihakset pääsevät mahdollisimman rennoiksi venytyksen aikana. Painovoima vaikuttaa kuitenkin aina alaspäin ja joskus 
            on hyötyä muuttaa tätä suuntaa. Vastuskuminauhalla voidaan muuttaa tätä "painovoiman" suuntaa halutuksi siten että saadaan 
            veto kohdistumaan vaikka sivulle tai eteenpäin.</p>

            <p>Tehokkaita venytyksiä on esimerkiksi lonkankoukistajan venytys ja olkanivelen liikkuvuusharjoitteet.</p>

            <img src="/svelte-site/img/blog/2014/lonkankoukistaja.jpg" alt="lonkankoukistajan venytys" />
            <p class="kuvateksti">Lonkankoukistajan venytys</p>

            <h2>5. Väline treenien alkulämmittelyyn</h2>
            
            <p>Kuminauhajuoksu on hauska ja tehokas tapa hoitaa alkulämmittely ja sen voi tehdä yksin tai parin kanssa. 
            Tehokkaasti tehtynä toimii myös erillisenä nopeusvoimaharjoituksena!</p>
            
            <p>Myös raskaiden kehonpainoliikkeiden keventäminen vastuskuminauhalla toimii lämmittelyssä. Valitse tarpeeksi vahva vastuskuminauha, 
            jotta dippi ja leuanveto tuntuvat kevyeltä - näin voit tehdä liikkeitä kevennettynä lämmittelyliikkeenä kuormittamatta liikaa jänteitä, 
            niveliä ja lihaksia ennen kuin ne ovat kunnolla lämpimät.</p>

            
            <img src="/svelte-site/img/blog/2014/kumpparijuoksu.jpg" alt="kuminauhajuoksu" /> 
            
            
            
            <h2>6. Tasapainon horjuttaminen</h2>
            
            <p>Kokeile laittaa kahvakuula levytangon päihin kuminauhalla sidottuna ja tee seisten pystypunnerrusliike. 
                Huomaat että kehon tasapaino joutuu uudenlaiselle koetukselle. 
                Ei ehkä ihan jokapäiväisiin treeneihin soveltuva liike, mutta satunnaisesti tehtynä äärimmäisen haastava shokkiliike!</p>
                
            <p>Kokeile menetelmää myös valakyykkyyn tai penkkipunnerrukseen. Ole kuitenkin varovainen liikettä tehdessä; 
                huolehdi että sinulla on varmistaja tai voit laskea painot turvallisesti alas jos tasapaino pettää yllättäen.</p>
                
            <img src="/svelte-site/img/blog/2014/valakyykky.jpg" alt="valakyykky" />
            <p>Hyviä treenejä!</p>

            <p>- Mata</p>

    </article>



    <section class="container">
        <h2>Lue seuraavaksi</h2>
        <div class="row">
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='ranteiden_huolto' title='Ranteiden liikkuvuus ja huolto' titlePic='ranne.jpg' blogDate='' firstPara='Ärtyneet ja kipeät ranteet vaivaavat nykyisin yhä useampaa ihmistä. Vaiva on yleistynyt samalla kun työnkuva on muuttunut enemmän paikallaan nöpöttämiseksi hiiren tai muun laitteen parissa. Lue tästä, mitä voit itse tehdä ranteidesi hyväksi.'></BlogSummary>
            </article>
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='6-syyta-tehda-nopeusvoimaharjoittelua' title='6 syytä tehdä nopeusvoimaharjoittelua' titlePic='nopeusharjoittelu.jpg' blogDate='' firstPara='Lihasten tuottama voima voidaan lajitella käytännössä kolmeen luokkaan. Kaiken kivijalka on kestovoima, jonka päälle rakennetaan maksimi- ja nopeusvoima.'></BlogSummary>
            </article>
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='juoksuvoimaa_lihaskuntoharjoittelusta' 
                title='Juoksuvoimaa lihaskuntoharjoittelusta' titlePic='2018/juoksutreenit.jpg' firstPara='Lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle. Voimaa tarvitaan niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.' blogDate=''></BlogSummary>
            </article>
        </div>
    </section>

</div>

{/if}

<style>
</style>
